export function modalConfirm(message, title = 'Confirm...', okBtn = 'Ok', cancelBtn = 'Cancel') {
	return new Promise(done => {
		var confirmed = false;
		$("#confirmModal").find('.modal-body').html(`<p>${message}</p>`);
		$('#confirmModal-ok').html(okBtn);
		$('#confirmModal-cancel').html(cancelBtn);
		$("#confirmModalLabel").html(title);
		$("#confirmModal").modal('show');
		$('#confirmModal').one('hidden.bs.modal', function (event) {
			done(confirmed);
		});
		$('#confirmModal-ok').one('click', function (e) {
			confirmed = true;
		});
	});
}